export interface TaskTypeManagementState {
    taskTypes: any[]
    loading: boolean
}

export const initialState: TaskTypeManagementState = {
    taskTypes: [],
    loading: false
}
